import numberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { connect } from "react-redux";
export default connect(state => ({ value: state.marketing.totals.introsSold, disableAnimation: state.marketing.currentUser.qa }))(numberDisplay);
